// extracted by mini-css-extract-plugin
export default {"PostDetail":"PostDetail_PostDetail__MCCtc","PostDetailDescr":"PostDetail_PostDetailDescr__XcDRi"};